// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class NoteTypeModels {
    static getAttributeTypeMap() {
        return NoteTypeModels.attributeTypeMap;
    }
}
NoteTypeModels.discriminator = undefined;
NoteTypeModels.additionalProperties = false;
NoteTypeModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=noteTypeModels.js.map